import { render } from "./TitleBox.vue?vue&type=template&id=69500159&ts=true"
import script from "./TitleBox.vue?vue&type=script&lang=ts"
export * from "./TitleBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__